import logo from "./logo.svg";
import "./App.css";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    BrowserRouter,
} from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./Home";
import SideIcons from "./SideIcons";
import Layout from "./Layout";
import Pawfect from "./Pages/Pawfect";
import Pomodoro from "./Pages/Pomodoro";
import TriviaNight from "./Pages/TriviaNight";
import MyProfile from "./Pages/MyProfile";
import { useEffect } from "react";
// https://blog.uxfol.io/professional-portfolio/
export default function App() {
    useEffect(() => {
        document.title = "Jack King - Portfolio";
    }, []);
    return (
        <div className="flex flex-auto lg:p-0 lg:w-1/3 lg:mx-auto text-black">
            <div className="">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Layout />}>
                            <Route index element={<Home />} />
                            {/* <Route path="/products" element={<Products />} /> */}
                            <Route path="/pawfectecom" element={<Pawfect />} />
                            <Route
                                path="/trivianight"
                                element={<TriviaNight />}
                            />
                            <Route path="/pomodoro" element={<Pomodoro />} />
                            <Route path="/profile" element={<MyProfile />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        </div>
    );
}
